import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import { aliases, mdi } from 'vuetify/iconsets/mdi-svg'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

const myCustomLightTheme = {
    dark: false,
    colors: {
        whiteEver: '#FFFFFF',
        blackEver: '#303030',
        base: '#FFFFFF',
        'background-regular-active': '#F0E6FC',
        'background-regular-selected': '#303030',
        'background-regular-default': '#FAFAFA',
        'background-regular-hover': '#EFEFEF',
        'background-regular-disabled': '#EFEFEF',
        'background-success-default': '#E8F7F4',
        'background-primary-default': '#7F4CF7',
        'background-primary-hover': '#9368FC',
        'background-info-default': '#E6F4FC',
        'background-error-default': '#FDEEF0',
        'background-warning-regular': '#FEF6E3',
        'font-regular': '#303030',
        'font-secondary': '#909090',
        'font-success': '#0BA085',
        'font-reverse': '#FFFFFF',
        'font-info': '#49A7EB',
        'font-error': '#DD424D',
        'font-default': '#B0B0B0',
        'font-disabled': '#C0C0C0',
        'font-warning': '#F9C541',
        'font-primary-default': '#7F4CF7',
        'font-primary-disabled': '#CFB3FC',
        'border-default': '#EFEFEF',
        'border-divider': '#DFDFDF',
        'border-error': '#DD424D',
        'border-success': '#0BA085',
        'border-primary-inactive': '#E0CCFC',
        'border-primary-active': '#7F4CF7',
        amenities: '#D65800',
        'amenities-background': '#FDF7F2',
    }
}

const myCustomDarkTheme = {
    dark: true,
    colors: {
        whiteEver: '#FFFFFF',
        blackEver: '#303030',
        base: '#FFFFFF',
        'background-regular-active': '#F0E6FC',
        'background-regular-selected': '#303030',
        'background-regular-default': '#FAFAFA',
        'background-regular-hover': '#EFEFEF',
        'background-regular-disabled': '#EFEFEF',
        'background-success-default': '#E8F7F4',
        'background-primary-default': '#7F4CF7',
        'background-primary-hover': '#9368FC',
        'background-info-default': '#E6F4FC',
        'background-error-default': '#FDEEF0',
        'background-warning-regular': '#FEF6E3',
        'font-regular': '#303030',
        'font-secondary': '#909090',
        'font-success': '#0BA085',
        'font-reverse': '#FFFFFF',
        'font-info': '#49A7EB',
        'font-error': '#DD424D',
        'font-default': '#B0B0B0',
        'font-disabled': '#C0C0C0',
        'font-warning': '#F9C541',
        'font-primary-default': '#7F4CF7',
        'font-primary-disabled': '#CFB3FC',
        'border-default': '#EFEFEF',
        'border-divider': '#DFDFDF',
        'border-error': '#DD424D',
        'border-success': '#0BA085',
        'border-primary-inactive': '#E0CCFC',
        'border-primary-active': '#7F4CF7',
        amenities: '#D65800',
        'amenities-background': '#FDF7F2',
    }
}

export default createVuetify({
    components,
    directives,
    defaults: {
        VOverlay: {
            transition: false,
        },
        VDialog: {
            transition: false,
        },
        VMenu: {
            transition: false,
        },
        VAutocomplete: {
            transition: false,
        },
        VSelect: {
            transition: false,
        },
        VCombobox: {
            transition: false,
        },
    },
    theme: {
        defaultTheme: 'myCustomLightTheme',
        themes: {
            myCustomLightTheme,
            myCustomDarkTheme
        }
    },
    icons: {
        defaultSet: 'mdi',
        aliases,
        sets: {
            mdi,
        },
    },
})
